'use client';

const values = [
  {
    icon: 'ri-leaf-line',
    title: 'Natural Purity',
    description: 'We use only the finest organic herbs and natural ingredients, free from harmful chemicals and artificial additives.',
    color: 'bg-green-100 text-green-600'
  },
  {
    icon: 'ri-ancient-gate-line',
    title: 'Ancient Wisdom',
    description: 'Our formulations are based on thousands of years of Ayurvedic knowledge and traditional healing practices.',
    color: 'bg-amber-100 text-amber-600'
  },
  {
    icon: 'ri-microscope-line',
    title: 'Modern Science',
    description: 'We combine traditional wisdom with modern scientific research to create the most effective products.',
    color: 'bg-blue-100 text-blue-600'
  },
  {
    icon: 'ri-earth-line',
    title: 'Sustainability',
    description: 'We are committed to sustainable sourcing and environmentally responsible practices in all our operations.',
    color: 'bg-emerald-100 text-emerald-600'
  },
  {
    icon: 'ri-hand-heart-line',
    title: 'Customer Care',
    description: 'Your wellness journey is our priority. We provide personalized support and guidance every step of the way.',
    color: 'bg-pink-100 text-pink-600'
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Trust & Transparency',
    description: 'We maintain the highest standards of quality and provide complete transparency about our ingredients and processes.',
    color: 'bg-indigo-100 text-indigo-600'
  }
];

export default function Values() {
  return (
    <section className="py-12 sm:py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Core Values
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            These principles guide everything we do, from sourcing ingredients to 
            crafting products that transform lives naturally.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {values.map((value, index) => (
            <div key={index} className="group">
              <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-6 sm:p-8 text-center transform hover:-translate-y-2">
                <div className={`w-16 h-16 flex items-center justify-center ${value.color} rounded-full mx-auto mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${value.icon} text-2xl`}></i>
                </div>
                
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4">
                  {value.title}
                </h3>
                
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  {value.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 sm:mt-16 bg-gradient-to-r from-green-600 to-green-800 rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-12 text-center text-white">
          <h3 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4">
            Join Our Wellness Community
          </h3>
          <p className="text-base sm:text-lg md:text-xl mb-6 sm:mb-8 opacity-90 max-w-2xl mx-auto">
            Discover the transformative power of Ayurveda and embark on your journey 
            to natural wellness with thousands of satisfied customers worldwide.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
            <a href="/products" className="bg-white text-green-600 px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:bg-green-50 transition-colors whitespace-nowrap">
              Shop Products
            </a>
            <a href="/contact" className="border-2 border-white text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:bg-white hover:text-green-600 transition-all duration-300 whitespace-nowrap">
              Get Consultation
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}